import { DexieDatabase, ExtratoCarteiraPrevidencia } from './../services/db';

export class ExtratoPrevicenciaRepository {
  constructor(private readonly db: DexieDatabase) {}

  getExtratosByCPFAndProposta(params: { cpf: string; proposta: string }) {
    return this.db.extratoCarteira
      .where({ cpf: params.cpf, proposta: params.proposta })
      .toArray();
  }

  add(body: ExtratoCarteiraPrevidencia) {
    return this.db.extratoCarteira.add(body);
  }

  updateExtrato(id: number, url: string, expiration_time: number) {
    return this.db.extratoCarteira.update(id, {
      pdf_url: url,
      pdf_date_expiration: expiration_time
    });
  }
}
